// components/Header.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from '../styles/Header.module.css';
import Logo from '../images/nadali.jpg';
import Button from './Button';

export default function Header() {
  const navigate = useNavigate();

  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header className={`${styles.header} ${isScrolled ? styles.Scrolled : ''}`}>
        <div className={styles.logoWrapper}>
          <img src={Logo} alt="Nadali Logo" />
        </div>

        <div
          className={`${styles.mobileButton} ${menuOpen ? styles.open : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className={`${styles.line} ${styles.line1}`}></span>
          <span className={`${styles.line} ${styles.line2}`}></span>
          <span className={`${styles.line} ${styles.line3}`}></span>
        </div>

        {/* Desktop buttons */}
        <div className={styles.headerButtons}>
          <Button variant="header" onClick={() => navigate('/')}>
            Home
          </Button>
          <Button variant="header" onClick={() => navigate('/contact')}>
            Contact us
          </Button>
          <Button variant="primary" onClick={() => navigate('/menu')}>
            Menu
          </Button>
    
          {/* <Button variant="primary" onClick={() => navigate('/order')}>
            Order Now
          </Button> */}
        </div>
      </header>

      {/* Mobile slide-in menu */}
      <nav className={`${styles.mobileMenu} ${menuOpen ? styles.open : ''}`}>
        <Button variant="header" onClick={() => { navigate('/'); closeMenu(); }}>
          Home
        </Button>
        <Button variant="header" onClick={() => { navigate('/contact'); closeMenu(); }}>
          Contact Us
        </Button>
        <Button variant="primary" onClick={() => { navigate('/menu'); closeMenu(); }}>
          Menu
        </Button>
        {/* <Button variant="primary" onClick={() => { navigate('/order'); closeMenu(); }}>
          Order Now
        </Button> */}
      </nav>

      {/* 
        IMPORTANT: These hidden links help react-snap discover routes during pre-rendering
        Do NOT remove this block
      */}
      <div style={{ display: 'none' }}>
        <a href="/">Home</a>
        <a href="/contact">Contact Us</a>
        <a href="/menu">Menu</a>
        {/* <a href="/order">Order Now</a> */}
      </div>
    </>
  );
}